import './Section.css.proxy.js';
/* src/components/slot/Section.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_text,
	create_component,
	create_slot,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	set_data,
	set_style,
	text,
	toggle_class,
	transition_in,
	transition_out,
	update_slot
} from "../../web_modules/svelte/internal.js";

import Button from "../button/Simple.js";

function create_if_block_1(ctx) {
	let p;
	let t0;
	let h2;
	let t1;

	return {
		c() {
			p = element("p");
			t0 = text(/*en*/ ctx[1]);
			h2 = element("h2");
			t1 = text(/*name*/ ctx[0]);
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			t0 = claim_text(p_nodes, /*en*/ ctx[1]);
			p_nodes.forEach(detach);
			h2 = claim_element(nodes, "H2", { class: true });
			var h2_nodes = children(h2);
			t1 = claim_text(h2_nodes, /*name*/ ctx[0]);
			h2_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "svelte-1ujdh6r");
			attr(h2, "class", "svelte-1ujdh6r");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t0);
			insert(target, h2, anchor);
			append(h2, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*en*/ 2) set_data(t0, /*en*/ ctx[1]);
			if (dirty & /*name*/ 1) set_data(t1, /*name*/ ctx[0]);
		},
		d(detaching) {
			if (detaching) detach(p);
			if (detaching) detach(h2);
		}
	};
}

// (11:228) {#if more}
function create_if_block(ctx) {
	let div;
	let button;
	let current;

	button = new Button({
			props: {
				name: /*more*/ ctx[2][1],
				action: /*more*/ ctx[2][0],
				kind: "link"
			}
		});

	return {
		c() {
			div = element("div");
			create_component(button.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(button.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "more svelte-1ujdh6r");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(button, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};
			if (dirty & /*more*/ 4) button_changes.name = /*more*/ ctx[2][1];
			if (dirty & /*more*/ 4) button_changes.action = /*more*/ ctx[2][0];
			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(button);
		}
	};
}

function create_fragment(ctx) {
	let section;
	let div;
	let section_class_value;
	let current;
	let if_block0 = /*name*/ ctx[0] && create_if_block_1(ctx);
	const default_slot_template = /*#slots*/ ctx[8].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[7], null);
	let if_block1 = /*more*/ ctx[2] && create_if_block(ctx);

	return {
		c() {
			section = element("section");
			if (if_block0) if_block0.c();
			div = element("div");
			if (default_slot) default_slot.c();
			if (if_block1) if_block1.c();
			this.h();
		},
		l(nodes) {
			section = claim_element(nodes, "SECTION", { class: true, style: true });
			var section_nodes = children(section);
			if (if_block0) if_block0.l(section_nodes);
			div = claim_element(section_nodes, "DIV", { class: true });
			var div_nodes = children(div);
			if (default_slot) default_slot.l(div_nodes);
			div_nodes.forEach(detach);
			if (if_block1) if_block1.l(section_nodes);
			section_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "contents svelte-1ujdh6r");
			attr(section, "class", section_class_value = "section__" + /*size*/ ctx[3] + " section__" + /*kind*/ ctx[4] + " section__" + /*color*/ ctx[5] + " svelte-1ujdh6r");
			set_style(section, "background-image", "url(" + /*background*/ ctx[6] + ")");
			toggle_class(section, "section__image", /*background*/ ctx[6]);
		},
		m(target, anchor) {
			insert(target, section, anchor);
			if (if_block0) if_block0.m(section, null);
			append(section, div);

			if (default_slot) {
				default_slot.m(div, null);
			}

			if (if_block1) if_block1.m(section, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*name*/ ctx[0]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(section, div);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 128) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[7], dirty, null, null);
				}
			}

			if (/*more*/ ctx[2]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*more*/ 4) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(section, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (!current || dirty & /*size, kind, color*/ 56 && section_class_value !== (section_class_value = "section__" + /*size*/ ctx[3] + " section__" + /*kind*/ ctx[4] + " section__" + /*color*/ ctx[5] + " svelte-1ujdh6r")) {
				attr(section, "class", section_class_value);
			}

			if (!current || dirty & /*background*/ 64) {
				set_style(section, "background-image", "url(" + /*background*/ ctx[6] + ")");
			}

			if (dirty & /*size, kind, color, background*/ 120) {
				toggle_class(section, "section__image", /*background*/ ctx[6]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(section);
			if (if_block0) if_block0.d();
			if (default_slot) default_slot.d(detaching);
			if (if_block1) if_block1.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { name = null } = $$props;
	let { en = null } = $$props;
	let { more = null } = $$props;
	let { size = null } = $$props;
	let { kind = null } = $$props;
	let { color = null } = $$props;
	let { background = null } = $$props;

	$$self.$$set = $$props => {
		if ("name" in $$props) $$invalidate(0, name = $$props.name);
		if ("en" in $$props) $$invalidate(1, en = $$props.en);
		if ("more" in $$props) $$invalidate(2, more = $$props.more);
		if ("size" in $$props) $$invalidate(3, size = $$props.size);
		if ("kind" in $$props) $$invalidate(4, kind = $$props.kind);
		if ("color" in $$props) $$invalidate(5, color = $$props.color);
		if ("background" in $$props) $$invalidate(6, background = $$props.background);
		if ("$$scope" in $$props) $$invalidate(7, $$scope = $$props.$$scope);
	};

	return [name, en, more, size, kind, color, background, $$scope, slots];
}

class Section extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			name: 0,
			en: 1,
			more: 2,
			size: 3,
			kind: 4,
			color: 5,
			background: 6
		});
	}
}

export default Section;
//# sourceMappingURL=Section.js.map
